
export const CERTIFICATE_TYPES = {
  TRAINING: "TRAINING",
  EXPERIENCE: "EXPERIENCE",
  SELF_UPLOADED: "SELF_UPLOADED",
}

export default CERTIFICATE_TYPES
